import Swal from "sweetalert2";
// bu class sweetalertin kullanımını kolaylaştırmak için yazılmıştır. her seferinde styling yapmak yerine bu classi yazdik

export const Toast = (
  title,
  content,
  icon,
  onSubmit,
  onCancel,
  showCancelButton
) => {
  const Toast = Swal.mixin({
    customClass: {
      confirmButton: "bg-primary",
      cancelButton: "bg-red-400",
    },
    buttonsStyling: true,
    showCancelButton: true,
    cancelButtonText: "Kapat",
    confirmButtonText: "Tamam",
  });

  Toast.fire({
    title: title,
    text: content,
    icon: icon,
    allowOutsideClick: false,
    showCancelButton: showCancelButton ?? false,
  }).then((result) => {
    if (result.isConfirmed) {
      if (onSubmit) onSubmit();
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      if (onCancel) onCancel();
    } else {
      return;
    }
  });
};
